<!--填空 SBQ-->
<template>
	<div class="question-container" style="border: 1px solid #EDEFF2;">
		<div class="question-type">填空</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<!-- <p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
				<span style="color: #4c4a56" v-html="renderCaseProblem">
				</span>
			</p> -->
			<p class="question-row">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				<span class="index">{{
				`${dataObj.questionIndex || index + 1}、`
				}}</span>

				<!-- 富文本 + 后缀文字 放在同一个容器里 -->
				<span class="rich-text-wrapper">
				<span class="rich-text-content" v-html="dataObj.caseProblem"></span>
				</span>
			</p>
		</div>
		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>
		<div class="item" v-for="(item, index) in answerObj.answer" :key="index" style="margin-top: 10px;">
			<div class="number">{{ index+1 }}</div>
			<div class="input-container" style="border: 1px solid #EDEDED;">
				<input placeholder-class="input-placeholder" v-model="item.context" :placeholder="'请输入'"
					style="width: 100%;" :disabled="operate !== 'answer'" @blur="handleInputBlur(item, index)"></input>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
			operate: {	
				type: String,
				default: "",
			},
		},
		data() {
			return {
				dataObj: {},
				answerObj: {},
				index: 0,
				list: [],
				count: 3,
				isMultiple: true,
				images: [],
				rules: [],
				value: "",
			};
		},
		methods: {
			handleInputBlur() {
				this.dataObj.answer = this.answerObj.answer.map(item => {
					return {
					id: item.id,
					context: item.context
					}
				})
				this.$emit('update', JSON.stringify({
					data: this.dataObj,
					answer: {
					question_id: this.dataObj.id,
					type: this.dataObj.type,
					if_hide: this.dataObj.if_hide,
					answer: this.answerObj.answer
					},
					index: this.index
				}))
			}
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					if (this.dataObj.answer) {
						this.answerObj.answer = this.dataObj.answer.map(item => {
						return {
							id: item.id,
							context: item.context
						}
						})
					} else {
						const num = this.dataObj.caseProblem.split("____").length - 1
						// 构建答案数据
						let answer = []
						for (let j = 0; j < num; j++) {
						answer.push({
							id: '',
							context: ''
						})
						}
						this.answerObj.answer = answer
					}
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || "[]");

					const caseProblem = this.dataObj.caseProblem || "";
					let count = 0;

					const replaced = caseProblem.replace(/____/g, () => {
						const html = `
		          <span style="border-bottom: 1px solid #494949; padding-bottom: 3px; position: relative; top: -3px;">
		            <b style="
		              font-weight: normal;
		              font-size: 10px;
		              color: #494949;
		              text-align: center;
		              display: inline-flex;
		              align-items: center;
		              justify-content: center;
		              border: 1px solid #494949;
		              width: 15px;
		              height: 15px;
		              border-radius: 25px;
		              margin-left: 10px;
		              margin-right: 8px;
		            ">
		              ${count + 1}
		            </b>
		          </span>
		        `;
						count++;
						return html;
					});
					this.renderCaseProblem = replaced;

					// const answerList = [];
					// for (let i = 0; i < count; i++) {
					// 	answerList.push({
					// 		id: "",
					// 		context: ""
					// 	});
					// }

					// if (newVal.answer && Array.isArray(newVal.answer.answer)) {
					// 	newVal.answer.answer.forEach((ans, idx) => {
					// 		if (answerList[idx]) {
					// 			answerList[idx].context = ans.context || "";
					// 			answerList[idx].id = ans.id || "";
					// 		}
					// 	});
					// }

					// this.list = answerList;
				},
				deep: true,
				immediate: true,
			}
		}
	};
</script>

<style scoped>
	.question-logic {
		position: absolute;
		right: 13px;
		top: 28px;
		width: 13px;
		height: 12px;
	}
	
	.item {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	
	.item .number {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		border: 1px solid #000;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewSBQ.vue